import React, { useEffect, useState } from "react";
import { withStyles } from '@material-ui/core/styles';
import { api_url } from '../../../js_assets/ConfigApp';
import { getParameterByName } from '../../../js_assets/getParameterByName'
import axios from 'axios'
import AppAdminContainer from '../AppAdminContainer'

import { useForm, Controller } from "react-hook-form";



function Subscription_Schedule_Trainer(props) {
    const { getValues, setValue, handleSubmit, errors, register, watch } = useForm({});
    const values = watch();
    const [Schedule_Package_Type_Data, setSchedule_Package_Type_Data] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        register("trainer_Id", { required: true });
        register("followUp_Schedule_Id", { required: true });
        register("followUp_Schedule_Name", { required: true });
        register("followUp_Schedule_Description", { required: true });


    }, []);


    useEffect(() => {
        axios.get(`${api_url}/api/trainer/Schedule_Package_Type`)
            .then(result => {
                setSchedule_Package_Type_Data(result.data)
            })
        let ActionType_Edit = getParameterByName("Edit")
        let ActionType_New = getParameterByName("New")

        if (ActionType_Edit !== null) {
            ///api/trainer/Get_FollowUp_Schedule/${ActionType}
            axios.get(`${api_url}/api/trainer/Get_FollowUp_Schedule/${ActionType_Edit}`)
                .then(result => {



                    setValue("followUp_Schedule_Id", result.data[0].followUp_Schedule_Id);

                    setValue("trainer_Id", result.data[0].trainer_Id);

                    setValue("followUp_Schedule_Price", result.data[0].followUp_Schedule_Price);

                    setValue("followUp_Schedule_Description", result.data[0].followUp_Schedule_Description);

                    setValue("followUp_Schedule_Name", result.data[0].followUp_Schedule_Name);

                    setValue("schedule_Package_Type_Id", result.data[0].schedule_Package_Type_Id);

                    setValue("Schedule_Duration", result.data[0].schedule_Duration);

                    setValue("followUp_Schedule_Old_Price", result.data[0].followUp_Schedule_Old_Price);

                })

        } else if (ActionType_New != null) {



            setValue("trainer_Id", parseInt(ActionType_New));


            setValue("followUp_Schedule_Id", 0);

            setValue("schedule_Package_Type_Id", 1);


        }
    }, []);




    function Save_FollowUp_Schedule() {

        setIsLoading(true)

        let Schedule_Trainer = {
            followUp_Schedule_Id: parseInt(values.followUp_Schedule_Id),
            trainer_Id: parseInt(values.trainer_Id),
            followUp_Schedule_Price: parseInt(values.followUp_Schedule_Price),
            followUp_Schedule_Description: values.followUp_Schedule_Description,
            followUp_Schedule_Name: values.followUp_Schedule_Name,
            Schedule_Package_Type_Id: parseInt(values.schedule_Package_Type_Id),
            Schedule_Duration: parseInt(values.Schedule_Duration),
            followUp_Schedule_Old_Price: parseInt(values.followUp_Schedule_Old_Price)
        }

        axios.post(`${api_url}/api/trainer/Save_Schedule_Trainer`, JSON.stringify(Schedule_Trainer), { headers: { 'Content-type': 'application/json; charset=utf-8' } })
            .then(() => {

                alert("تم الحفظ");
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                alert(error)
            });

    }






    let optionItems_schedule_Package_Type = Schedule_Package_Type_Data.length && Schedule_Package_Type_Data.map((data) => <option value={data.schedule_Package_Type_Id} key={data.schedule_Package_Type_Id}>{data.schedule_Package_Type_Name}</option>);
    return (

        <AppAdminContainer Title={"الجدوال"}>
            <div className="container">

                <div >

                    <input
                        placeholder="اسم الجدول"
                        name="followUp_Schedule_Name"
                        onChange={e => setValue("followUp_Schedule_Name", e.target.value)}
                        value={values.followUp_Schedule_Name} />

                </div>

                <div >

                    <select
                        name="schedule_Package_Type"
                        className="select"
                        onChange={e => setValue("schedule_Package_Type_Id", e.target.value)}
                    >
                        {optionItems_schedule_Package_Type}
                    </select>
                </div>

                <div >

                    <textarea rows={7}
                        value={values.followUp_Schedule_Description}
                        onChange={e => setValue("followUp_Schedule_Description", e.target.value)}
                        name="followUp_Schedule_Description" required />
                </div>

                <div >

                    <input
                        placeholder="السعر"
                        name="followUp_Schedule_Price"
                        onChange={e => setValue("followUp_Schedule_Price", e.target.value)}
                        value={values.followUp_Schedule_Price}
                    />
                </div>

                <div >
                    <input
                        placeholder="السعر قبل"
                        onChange={e => setValue("followUp_Schedule_Old_Price", e.target.value)}
                        value={values.followUp_Schedule_Old_Price}
                        name="followUp_Schedule_Old_Price" />

                </div>

                <div >
                    <input
                        placeholder="المدة"
                        value={values.Schedule_Duration}
                        onChange={e => setValue("Schedule_Duration", e.target.value)}
                        name="Schedule_Duration" required />

                </div>

                <div className="center">
                    <button
                        disabled={isLoading}
                        onClick={() => Save_FollowUp_Schedule()}   >
                        حفظ

                    </button>
                </div>

            </div>






        </AppAdminContainer >




    )
}




export default Subscription_Schedule_Trainer;